var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDifficulty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#7029a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.2124 14.393h-7.3162c-0.49793 0-0.89627 0.3983-0.89627 0.8962v14.964c0 0.4978 0.39834 0.8962 0.89627 0.8962h7.3162c0.49792 0 0.89627-0.3984 0.89627-0.8962v-14.964c0-0.4979-0.39835-0.8962-0.89627-0.8962zm-0.89626 14.964h-5.5237v-13.172h5.5237z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.658 0.84979h-7.3162c-0.4979 0-0.8963 0.39834-0.8963 0.89627v28.508c0 0.4981 0.3984 0.8962 0.8963 0.8962h7.3162c0.4979 0 0.8962-0.3981 0.8962-0.8962v-28.508c0-0.49129-0.3983-0.89627-0.8962-0.89627zm-6.4199 1.7925h1.6796l-1.6796 1.6797zm5.5236 26.715h-1.507l1.507-1.5069zm0-4.0431c-0.0066 0.0067-0.0066 0.0067-0.0133 0.0133l-4.0298 4.0298h-1.4805v-2.4896l5.5236-5.5236zm0-6.4996c-0.0066 0.0067-0.0066 0.0067-0.0133 0.0133l-5.5103 5.5104v-4.4946l5.5236-5.5237zm0-7.0307c-0.0066 0.0067-0.0066 0.0067-0.0133 0.0133l-5.5103 5.5104v-3.8174l5.5236-5.5237zm0-6.3535c-0.0066 0.00664-0.0066 0.00664-0.0133 0.01328l-5.5103 5.5103v-4.0962l4.1892-4.1892c0.0066-0.00664 0.0133-0.01992 0.0265-0.02656h1.3079z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.104 10.158h-7.3162c-0.498 0-0.8963 0.3983-0.8963 0.8963v19.2c0 0.4978 0.3983 0.8962 0.8963 0.8962h7.3162c0.4978 0 0.8962-0.3984 0.8962-0.8962v-19.2c0-0.498-0.4051-0.8963-0.8962-0.8963zm-0.8963 19.2h-5.5237v-17.407h5.5237z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDifficulty);
export default __webpack_public_path__ + "static/media/icon_difficulty.bc9a84143461c5280f564f423454536c.svg";
export { ForwardRef as ReactComponent };